export const isObject = (object: object): boolean =>
  typeof object === 'object' && object !== null && !Array.isArray(object);

export const isEmptyObject = (object: object): boolean => {
  return Array.isArray(object)
    ? object.length === 0
    : isObject(object) && Object.keys(object).length === 0;
};
